import { NetSuiteGetSubsidiariesResponseSchema } from '@vy/api-definition';
import type { NetSuiteGetSubsidiariesResponse } from '@vy/api-definition';
import { isNotEmptyString, validateNotEmptyString, withDefault } from '@vy/utils';
import type { QueryClient } from 'react-query';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../../../services/api';
import { queryKeys } from '../../../../services/query-key/query-keys';
import { useCanConnectNetSuite } from './use-can-connect-net-suite';
import type { CustomUseQueryOptions } from '../../requests-types/custom-use-query-options';

export function useNetSuiteUsers(
  erpId: string | undefined,
  options?: CustomUseQueryOptions<NetSuiteGetSubsidiariesResponse>,
) {
  const queryKey = getNetSuiteUsersQueryKey(erpId);
  const queryFunction = getNetSuiteUsersQueryFunction(erpId);

  const isNetSuiteActivated = useCanConnectNetSuite();

  const isActivatedInOptions = withDefault(options?.enabled, true);
  const enabled = isNotEmptyString(erpId) && isNetSuiteActivated && isActivatedInOptions;

  return useQuery(queryKey, queryFunction, {
    ...options,
    enabled,
  });
}

export function prefetchNetSuiteUsers(erpId: string, queryClient: QueryClient) {
  const queryKey = getNetSuiteUsersQueryKey(erpId);
  const queryFunction = getNetSuiteUsersQueryFunction(erpId);

  return queryClient.prefetchQuery(queryKey, queryFunction);
}

export function getNetSuiteUsersQueryKey(erpId: string | undefined) {
  return queryKeys.netSuiteSubsidiaries(erpId);
}

function getNetSuiteUsersQueryFunction(erpId: string | undefined) {
  return async () => {
    const api = getPrivateApi();
    validateNotEmptyString(erpId, 'erpId');
    const getSubsidiariesResponse = await api.getNetSuiteSubsidiaries({ erpId }, {});

    return NetSuiteGetSubsidiariesResponseSchema.parse(getSubsidiariesResponse);
  };
}
